import { ShieldCheck } from '@liveauctioneers/hammer-ui-core/icons';
import { useIntl } from '@liveauctioneers/hammer-ui-core/intl';
import { Link } from '@liveauctioneers/hammer-ui-core/link';
import { useWindowIsMobile } from '@liveauctioneers/hammer-ui-core/providers';
import { BodyPrimary } from '@liveauctioneers/hammer-ui-core/text';

import { BenefitsIconList } from '@/components/PurchaseProtection/PurchaseProtectionBanner/components/BenefitsIconList';
import { ItemPagePurchaseProtection } from '@/pages/Item/ItemPage/components/ItemPageMain/components/ItemPagePurchaseProtection/ItemPagePurchaseProtection';
import { TrackingEvents } from '@/utils/amplitude/analytics/core.types';
import { useTrackPurchaseProtectionLearnMoreAnalytics } from '@/utils/amplitude/analytics/purchaseProtection/trackPurchaseProtectionLearnMore.analytics';

export const PurchaseProtectionBanner = () => {
    const { formatMessage } = useIntl();
    const trackPurchaseProtectionLearnMoreAnalytics = useTrackPurchaseProtectionLearnMoreAnalytics();
    const isMobile = useWindowIsMobile();

    const handleLearnMoreClick = () => {
        trackPurchaseProtectionLearnMoreAnalytics(TrackingEvents.PurchaseProtection.LearnMorePurchaseProtection, {
            description:
                'User clicks on the "Learn More" link in the "Purchase Protection" section on the catalog page',
        });
    };

    const showInfoText = () => {
        return (
            <div className="mt-2xs flex justify-end hui-text-body-secondary text-xs text-text-secondary">
                {formatMessage({ id: 'purchaseProtectionPage.hero.info' })}
            </div>
        );
    };

    if (isMobile) {
        return (
            <div
                className="mb-sm"
                data-testid="purchaseProtectionBanner"
            >
                <ItemPagePurchaseProtection
                    className="border-border-black"
                    onLearnMoreClick={handleLearnMoreClick}
                />
                {showInfoText()}
            </div>
        );
    }

    return (
        <div
            className="mb-lg"
            data-testid="purchaseProtectionBanner"
        >
            <div className="shadow-md relative overflow-hidden rounded-lg border border-border-black">
                <div className="flex min-h-[152px] items-center justify-between gap-lg bg-background-primary py-md">
                    <div className="flex max-w-[60%] min-w-0 flex-1 flex-col items-start gap-2xs px-md pl-lg mdMin:max-w-[55%] smMax:max-w-[45%]">
                        <div className="flex w-full gap-xs">
                            <ShieldCheck
                                className="mt-xs shrink-0 self-start"
                                style="fill"
                            />
                            <span className="min-w-0 hui-text-h1 break-words">
                                {formatMessage({ id: 'purchaseProtectionPage.hero.title' })}
                            </span>
                        </div>
                        <div className="ml-[38px] w-full">
                            <BodyPrimary>
                                {formatMessage({ id: 'purchaseProtectionPage.hero.description' })}
                                <Link
                                    className="ml-2xs"
                                    href="/purchase-protection"
                                    onClick={handleLearnMoreClick}
                                >
                                    {formatMessage({ id: 'purchaseProtectionPage.hero.learnMore' })}
                                </Link>
                            </BodyPrimary>
                        </div>
                    </div>
                    <BenefitsIconList />
                </div>
            </div>
            {showInfoText()}
        </div>
    );
};
